import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/api/db'
import { setToken, getToken } from '@/libs/util'
import user from './module/user'
import app from './module/app'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    //字典列表
    dictList:{},
    nationsList:{},
    skillList:{},
    regionList:{},
    areaList:{},
    user_info:getToken("userInfo"),
    user_status:getToken("userStatus")
  },
  mutations: {
    //
    setDictList(state,data){
        state.dictList = data
    },
    setAreaList(state,data){
        state.areaList = data
    },
    setNations(state,data){
        state.nationsList = data
    },
    setSkills(state,data){
        state.skillList = data
    },
    setRegions(state,data){
        state.regionList = data
    },
    setUserStatus(state,data){
        state.user_status = data
        setToken(data,"userStatus")
    },
    setUserInfo(state,data){
        state.user_info = data.user
        setToken(data.user,"userInfo")
        state.token = data.token.access_token
        setToken(data.token.access_token)
    },
    setWechatUserInfo(state,data){
        state.wechat_user_info = data
        setToken(data,"wechatUserInfo")
    }
  },
  actions: {
    //查询字典值列表
    getDictList ({ commit }) {
        let dictList = this.state.dictList
        if(Object.keys(dictList).length != 0){
            return this.state.dictList
        }else{
            return  db.list(db.config.dict.list,false).then(resp=>{
                const data = resp.data
                commit('setDictList',data) 
                return resp.data
            })
        }    
    },
    /**
     * 查询省市县列表
     */
    getAreaList({commit}) {
        let province_list = {},city_list = {},county_list = {}
        let params = { level: 1};
        let areaList = this.state.areaList
        if(Object.keys(areaList).length != 0){
            return this.state.areaList
        }else{
            return db.post(db.config.area.list,params).then(resp=>{
                const province = resp.data
                province.forEach(element => {
                    province_list[element.value] = element.label;
                });          
            }).then(resp=>{
                params = { level: 2};
                db.post(db.config.area.list,params).then(resp=>{
                    const city = resp.data
                    city.forEach(element => {
                        city_list[element.value] = element.label;
                    });
                })
            }).then(resp=>{
                params = { level: 3};
                db.post(db.config.area.list,params).then(resp=>{
                    const county = resp.data
                    county.forEach(element => {
                        county_list[element.value] = element.label;
                    });
                })
            }).then(resp=>{
                let data = {}
                data.province_list = province_list
                data.city_list = city_list
                data.county_list = county_list
                commit('setAreaList',data)
                return data
            })
        }
    },


    //查询民族列表
    getNations ({commit}){
        let nationsList = this.state.nationsList
        if(Object.keys(nationsList).length != 0){
            return this.state.nationsList
        }else{
            return db.get(db.config.dict.nations).then(resp=>{
                const data = resp.data
                commit('setNations',data)
                return data
            })
        }
    },
    //志愿者技能
    getSkill ({commit}){
        let skillList = this.state.skillList
        if(Object.keys(skillList).length != 0){
            return this.state.skillList
        }else{
            return db.list(db.config.volunteer.skill.list).then(resp=>{
                const data = resp.data
                commit('setSkills',data)
                return data
            })
        }
    },
    //业务区域
    getRegions({commit}){
        let regionList = this.state.regionList
        if(Object.keys(regionList).length != 0){
            return this.state.regionList
        }else{
            return db.list(db.config.volunteer.regions.list).then(resp=>{
                const data = resp.data.data
                commit('setRegions',data)
                return data
            })
        }
    },
    //获取用户信息，主要是获取用户的各重身份状态
    getUserStatus({ commit }, { flag }){
        if(!flag){
            if(this.state.user_info){
                return db.get(db.config.user.url+"/"+this.state.user_info.id).then(resp=>{
                    const data = resp.data
                    commit('setUserStatus',data)
                    return data
                })
            }else{
                return false
            }
        }else{
            let userStatus = this.state.user_status
            if(userStatus){
                return this.state.user_status
            }else{
                if(this.state.user_info){
                    return db.get(db.config.user.url+"/"+this.state.user_info.id).then(resp=>{
                        const data = resp.data
                        commit('setUserStatus',data)
                        return data
                    })
                }else{
                    return false
                }
                 
            }
        }
        
    }
  },
  modules: {
    user,
    app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js